import { useState } from "react";
import { Link } from 'react-router-dom';
import { Bars4Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Header = (props) => {

    const [mobile, setMobile] = useState(false)

    const toggleNav = () => {
        setMobile(prevMobile => !prevMobile)
    }
    return ( 
        <div className="font-russo">
            <nav className="px-10 py-4 flex justify-between">
                <Link to="/" ><div className="text-xl md:text-2xl cursor-pointer" data-aos="fade-down-right"><span className="text-[#da6a1e]">code</span><span className="text-[#56606c]">Bro.</span></div></Link> 
                <div className="">

                    <div className="lg:hidden cursor-pointer" onClick={toggleNav}>{!mobile? <Bars4Icon className=" mr-2 w-8 text-[#56606c]" /> : <XMarkIcon className="mr-2 w-8 text-[#56606c]" />}</div>

                    
    
                    <ul className="hidden lg:flex">
                        {props.home && <a href="#about"><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black"  data-aos="fade-left">ABOUT</li></a> }
                        {props.home && <a href="#skills"><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black"  data-aos="fade-down">SKILLS</li></a>} 
                        {props.home && <a href='#contact'><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black"  data-aos="fade-down">CONTACT</li></a> }
                        {props.home ? <Link to="/portfolio" ><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black"  data-aos="fade-down">PORTFOLIO</li></Link> : <Link to="/" ><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black">HOME</li></Link>}
                        <a href="https://resume.io/r/NiPipjLB2" target="_blank" rel="noreferrer"><li className="px-4 text-sm hover:border-b-2 hover:scale-110 hover:border-black"  data-aos="fade-right">RESUME</li></a> 
                    </ul>
                </div>
                
            </nav>
            {mobile && <ul className="flex flex-col justify-center items-center py-5 lg:hidden">
                        {props.home && <a href="#about"><li className="px-4 py-10">ABOUT</li></a>}
                        {props.home && <a href="#skills"><li className="px-4 py-10">SKILLS</li></a>} 
                        {props.home && <a href='#contact'><li className="px-4 py-10">CONTACT</li></a> }
                        {props.home ? <Link to="/portfolio" ><li className="px-4 py-10">PORTFOLIO</li></Link> : <Link to="/" ><li className="px-4 py-10">HOME</li></Link>}
                        <a href="https://resume.io/r/NiPipjLB2" target="_blank" rel="noreferrer"><li className="px-4">RESUME</li></a>
                    </ul>}
        </div>
        
     );
}
 
export default Header;